var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-checkbox',{attrs:{"id":_vm.id,"type":"text","checked":_vm.checked,"switch":_vm.isSwitch,"size":_vm.size},model:{value:(_vm.newStatus),callback:function ($$v) {_vm.newStatus=$$v},expression:"newStatus"}})}
var staticRenderFns = []

export { render, staticRenderFns }